import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthGuard } from './auth.guard';
import { AuthUserGuard } from './authUser.guard';
import { AdminGuard } from './admin.guard';
import { CourseDataGuard } from './courseData.guard';
import { AdminDataGuard } from './adminData.guard';
import { UserFullAgeGuard } from './userFullAge.guard';
import { ModuleGuard } from './module.guard';
import { LoggedGuard } from './logged.guard';

export const Guards = [
  AuthGuard,
  AuthUserGuard,
  AdminGuard,
  CourseDataGuard,
  AdminDataGuard,
  ModuleGuard,
  LoggedGuard,
  UserFullAgeGuard,
];

@NgModule({
  imports: [
    CommonModule
  ]
})
export class GuardsModule {
  constructor(@Optional() @SkipSelf() parentModule: GuardsModule) {
    if (parentModule) {
      throw new Error('GuardsModule has already been loaded. You should only import Guards module in the AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<GuardsModule> {
    return {
      ngModule: GuardsModule,
      providers: Guards
    };
  }
}
